import React from 'react'
import { Spinner } from 'react-bootstrap'
import ReactPlayer from 'react-player/lazy'

const ListVideoComponent: React.FC<any> = ({
  id,
  videos,
  page,
  setPage,
  hasNextPage,
  loading,
  title,
  onSelectVideo,
  onResetListVideo
}) => {
  const onLoadMoreVideo = (e: any) => {
    e.preventDefault()
    setPage(page + 1)
  }

  const onSeeLessVideo = (e: any) => {
    e.preventDefault()
    onResetListVideo()
  }

  return (
    <div className="video-group mt-3" id={id}>
      <div className="head-line">
        <h3>{title}</h3>
        {hasNextPage && page === 1
          && (
            <a href="#" onClick={onLoadMoreVideo}>
              <i className="bi bi-chevron-down" /> もっと見る
            </a>
          )}
      </div>
      <div className="video-list">
        {
          videos && videos.map((video: any) => (
            <div key={video.id} className="video-items" data-content={video.title} role="presentation" onClick={() => onSelectVideo(video)}>
              <i className="bi bi-play-circle-fill play-icon" />
              {/* <img src={video.thumbnailUrl || '/assets/img/gmts-kun_icon_moji_tabetai_20px.png'} alt={video.title} /> */}
              {video.thumbnailUrl
                ? <img src={video.thumbnailUrl} alt={video.title} />
                : (
                  // <video height="100%" width="100%">
                  //   <source src={video.url} type="video/mp4" />
                  //   <track kind="captions" />
                  //   Your browser does not support HTML video.
                  // </video>
                  <ReactPlayer url={video.url} />
                )}
            </div>
          ))
        }
      </div>
      {page > 1
        && (
          <div className="list-video-footer">
            {hasNextPage
              && (
                <a href="#" className="me-3" onClick={onLoadMoreVideo}>
                  <i className="bi bi-chevron-down" /> もっと見る
                </a>
              )}
            <a href="#" onClick={onSeeLessVideo}>
              <i className="bi bi-chevron-up" /> 閉じる
            </a>
          </div>
        )}
      {loading && <Spinner animation="border" />}
    </div>
  )
}

export default ListVideoComponent
